import { render, staticRenderFns } from "./ApelidosHotel.vue?vue&type=template&id=f35de204&scoped=true"
import script from "./ApelidosHotel.vue?vue&type=script&lang=js"
export * from "./ApelidosHotel.vue?vue&type=script&lang=js"
import style0 from "./ApelidosHotel.vue?vue&type=style&index=0&id=f35de204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35de204",
  null
  
)

export default component.exports